import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpModelFilterableBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-model-filterable-base-component';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';


export interface Porte {
  id: number;
  keywords: string;
  name: string;
  image: string;
}

export class WizardHpModelFilterBaseComponent extends WizardHpBaseComponent implements OnInit {

  filterable : WizardHpModelFilterableBaseComponent;
  modele_filter: any;
  options: Porte[] = [];
  filteredOptions: Observable<Porte[]>;

  constructor(chgDetectorRef: ChangeDetectorRef, hpService: HpService, router: Router) {
    super(chgDetectorRef, hpService, router);

    this.modele_filter = this.getHpService().getConfig().herculepro.filter_parameters;

  }

  ngOnInit(): void {

    super.ngOnInit();

    
  }

  getFilterable() {
    return this.filterable;
  }

  public setLinkedFilterable(parentFilterable : WizardHpModelFilterableBaseComponent) {
    this.filterable = parentFilterable;
  }

  setFilter(ruleTxt: any, libSearch: any, callbackFn: any, callBackParams : any) {
    let me = this;

    var query = ruleTxt;
    if (libSearch != null && libSearch != '') {
      query = 'SEARCH_BY_LIB:' + encodeURIComponent(libSearch);
    }

    this.getHpService().searchModele(this.getHpService().getCatId(),
      query).subscribe(data => {

        var items = [];
        for (let i = 0; i < data.root.data.length; i++) {
          let item = {
            "id": data.root.data[i][0],
            "keywords": data.root.data[i][1],
            "name": data.root.data[i][2],
            "image": data.root.data[i][3]
          }
          items.push(item);
        }
        if (callbackFn != null) {

          var result = {
            items : items,
            callback_prms : callBackParams
          }
          callbackFn.call(me, result);
        }
       
        this.getHpService().emitDataChange();
        this.getChangeDetectorRef().detectChanges();
      });
      
      this.getHpService().emitDataChange();
  }

  public selectItem(item) {
    this.getHpService().selectItem(item.name, this.toNextLink, this).then(res =>{
    console.log(this.getHpService().getDrawing())
    this.getChangeDetectorRef().detectChanges();
    this.getHpService().emitDataChange();   
    });;
    console.log(this.getHpService().getDrawing())
    this.getChangeDetectorRef().detectChanges();
    this.getHpService().emitDataChange();   
  }
}
